
import request from '@/config'

import { DeptSearchDto } from './systems.dto';

enum Apis {
    GetEmpNoByWechat = `/api/sysuser/getempnobywechatno`
}

/* 使用微信ID获取用户工号 */
export const GetEmpNobyWechatApi = (wechatNo: string): Promise<IResponse> =>
    request.post({
        url: Apis.GetEmpNoByWechat,
        data: { wechat_no: wechatNo }
    });

export const GetDeptListApi = (search: DeptSearchDto): Promise<IResponse> => {

    return request.post({ url: '/api/sysdeptsingle/getselectlist', data: search })

}


